import axios from "axios";

// Empty means same origin, which is how the combined deployment serves the
// UI and the API together. Unset would otherwise yield "undefined/api/v1".
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
export const API_BASE = `${BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("eos_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  // A request to act in this tenant, never authority to do so: the backend
  // validates it against the user's memberships and denies otherwise.
  //
  // Platform routes are cross-tenant by definition and name their target in
  // the path, so sending a tenant header there is at best noise and at worst
  // misleading in a log. The backend ignores it either way.
  const tenant = localStorage.getItem("eos_tenant");
  if (tenant && !cfg.url?.startsWith("/platform")) cfg.headers["X-Tenant-Id"] = tenant;
  return cfg;
});

/**
 * Why Prioris staff are reaching into a customer's workspace.
 *
 * Recorded on the platform audit row, so the trail answers "why" and not only
 * "who" and "when". Kept as an explicit argument rather than ambient state:
 * a reason that lingers from a previous action and gets attached to an
 * unrelated one is worse than no reason at all.
 */
export const withReason = (reason) =>
  reason ? { headers: { "X-Platform-Reason": reason } } : {};

// The requests that can spend an AI credit. After one succeeds, anything
// showing the credit balance should refresh it.
const AI_TASK = /\/(assess|draft-reply|classify|recommend)$/;

api.interceptors.response.use(
  (r) => {
    if (r?.config?.method === "post" && AI_TASK.test(r.config.url || "")) {
      window.dispatchEvent(new CustomEvent("eos:ai-used"));
    }
    return r;
  },
  (err) => {
    // 402 means the plan does not cover this. It is a normal product state,
    // so surface it as an upgrade prompt rather than a failure.
    if (err?.response?.status === 402) {
      const d = err.response.data || {};
      window.dispatchEvent(new CustomEvent("eos:upgrade-required", { detail: d }));
    }
    if (err?.response?.status === 401) {
      localStorage.removeItem("eos_token");
      localStorage.removeItem("eos_user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
